// dayjs
import dayjs from "dayjs";
import timezonePlugin from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const abbreviateTimeZone = (zone: string) =>
  dayjs().tz(zone).format(`z`);
